'use client';

import { useTranslations } from 'next-intl';
import { lazy, Suspense, useState } from 'react';
import { Button } from '@//components/Button';
import { InfoStrip } from '@//components/InfoStrip';
import { useMarketMetadata } from '@//providers/MarketSettingsProvider';

const AutomotiveAssociationModal = lazy(() => import('./AutomotiveAssociationModal'));

export const AutomotiveAssociationBanner: React.FC = () => {
  const t = useTranslations('utils.automotiveAssociation');
  const marketMetadata = useMarketMetadata();
  const [modal, setModal] = useState(false);

  const name = marketMetadata.automotiveAssociation.name;

  return (
    <>
      <InfoStrip
        ariaLabel={t('banner.ariaLabel', { name })}
        logotype={
          marketMetadata.automotiveAssociation.logotype
            ? {
                src: marketMetadata.automotiveAssociation.logotype['1x'],
                srcSet: marketMetadata.automotiveAssociation.logotype['2x'],
                alt: name,
              }
            : undefined
        }
        action={
          <Button
            onClick={() => setModal(true)}
            title={t('banner.action.title', { name })}
            variant="outline"
            size="sm"
            noWrap
          >
            {t('banner.action.label', { name })}
          </Button>
        }
        testId="seller-automotive-association-banner"
        heading={t('banner.heading', { name })}
        headingLevel={3}
        description={t('banner.description', { name })}
      />
      <Suspense fallback={null}>
        <AutomotiveAssociationModal isOpen={modal} onClose={() => setModal(false)} />
      </Suspense>
    </>
  );
};
